module.exports = __webpack_public_path__ + "img/poker-d13.42d18bf5.svg";